import { StatusBadge } from 'app/concierge/types';
import { Box } from '@mui/material';
import parse from 'html-react-parser';
import React from 'react';

export default function JsonStatusBadge({ statusBadge }: { statusBadge: StatusBadge }) {
    return <Box>{parse(statusBadge.title)}</Box>;
}
